<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="productDetailLabelInfo.labels" border style="width: 100%" size="small">
        <el-table-column prop="labelName" label="标签名称" align="center" />
        <el-table-column prop="productId" label="商品ID" align="center" />
        <el-table-column label="商品图片" align="center">
          <template #default="{ row }">
            <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="row.coverPhoto" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="商品分组" align="center" />
        <el-table-column prop="prodName" label="商品名称" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryProductLabel } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailLabel',
  data() {
    return {
      productDetailLabelInfo: {
        labels: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailLabelInfo.productId = params.productId
      this.loadProductDetailLabelData()
    },
    async loadProductDetailLabelData() {
      const res = await queryProductLabel({
          productId: this.productDetailLabelInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })
      this.productDetailLabelInfo.labels = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailLabelData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>